import {SvgIconData} from '@shared_web/components/core/svg_icon';

export const icon_door_cycles: SvgIconData = {
  viewBox: '7 7 86 86',
  element: (
    <path d="M50 7c-3.152 0-6.227.34-9.187.988l1.035 3.864A39.2 39.2 0 0 1 50 11c21.562 0 39 17.438 39 39 0 12.043-5.441 22.801-14 29.953V74a2 2 0 1 0-4 0v10a2 2 0 0 0 2 2h10a2 2 0 1 0 0-4h-4.297C87.477 74.125 93 62.699 93 50 93 26.277 73.727 7 50 7m-33 8a2 2 0 1 0 0 4h3.219c-8.145 7.828-13.22 18.828-13.22 31 0 23.723 19.278 43 43 43 3.153 0 6.227-.34 9.188-.984l-1.035-3.864a39.2 39.2 0 0 1-8.152.852c-21.562 0-39-17.438-39-39 0-12.043 5.441-22.801 14-29.95v6.95c0 1.106.894 2 2 2s2-.894 2-2v-10a2 2 0 0 0-2-2z" />
  ),
};
